interface Props {
  current: number
  total: number
  streak: number
  studentName?: string
  onPause?: () => void
}

export function ProgressBar({ current, total, streak, studentName, onPause }: Props) {
  const progress = total === 0 ? 0 : Math.round((current / total) * 100)
  return (
    <section className="progress-panel v4-progress" aria-label="Progreso de la sesión">
      <div className="progress-copy">
        <div>
          <strong>{studentName ? `${studentName} · ` : ''}Pregunta {Math.min(current + 1, total)} de {total}</strong>
          <span>Racha: {streak}</span>
        </div>
        {onPause && <button className="pause-session-button" type="button" onClick={onPause}>Pausar y salir</button>}
      </div>
      <div className="progress-track" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={progress}>
        <span style={{ width: `${progress}%` }} />
      </div>
      <small className="autosave-note">El avance se guarda automáticamente en este dispositivo.</small>
    </section>
  )
}
